/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';
import TankResponse from './TankResponse';

/**
* The SearchTanksResponse model module.
* @module model/SearchTanksResponse
* @version 2020-12-7
*/
export default class SearchTanksResponse {
    /**
    * Constructs a new <code>SearchTanksResponse</code>.
    * @alias module:model/SearchTanksResponse
    * @class
    * @param tanks {Array.<module:model/TankResponse>} タンク
    * @param result {module:model/SearchTanksResponse.ResultEnum} 
    */

    constructor(tanks, result) {
        
        
        this['tanks'] = tanks;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchTanksResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchTanksResponse} obj Optional instance to populate.
    * @return {module:model/SearchTanksResponse} The populated <code>SearchTanksResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchTanksResponse();
                        
            
            if (data.hasOwnProperty('tanks')) {
                obj['tanks'] = ApiClient.convertToType(data['tanks'], [TankResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * タンク
    * @member {Array.<module:model/TankResponse>} tanks
    */
    'tanks' = undefined;
    /**
    * @member {module:model/SearchTanksResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
